import {format} from 'date-fns';
import React from 'react';
import {t} from '../../../common/getTranslations';
import {Icon} from '../../atoms/Icon/Icon';
import {IconType} from '../../atoms/Icon/IconType.enum';
import {Text} from '../../atoms/Text/Text';
import {LabelBadge} from '../../molecules/LabelBadge/LabelBadge';
import {LabelBadge18Type} from '../../molecules/LabelBadge/LabelBadge18Type.enum';
import {LabelBadgeSizeType} from '../../molecules/LabelBadge/LabelBadgeSizeType.enum';
import {MoreExpandListItemProps} from './MoreExpandListItemProps';

const MoreExpandListItem = React.memo(
  React.forwardRef<HTMLElement, MoreExpandListItemProps>(
    (
      {
        isActive,
        isLabelBadge,
        isResolved,
        title,
        createDt,
        id,
        createDtFormat,
        ...props
      },
      ref
    ) => {
      return (
        // TODO : data-id 를 제거하고 onclick 시 id를 넘겨주는 방식으로 변경 (도움말, 공지사항, 내문의내역 에서 사용 중)
        <dt
          ref={ref}
          data-id={id}
          className="cursor-pointer break-words bg-theme-bg-base pt-20pxr px-15pxr text-theme-solid-100"
          {...props}
        >
          <div className="flex items-center justify-between pb-20pxr border-b-1 border-theme-transparent-10 border-solid">
            <div>
              <div className="flex flex-row items-center gap-[6px]">
                {isLabelBadge && (
                  <LabelBadge
                    sizeType={LabelBadgeSizeType.Size18}
                    type={
                      isResolved
                        ? LabelBadge18Type.gray
                        : LabelBadge18Type.yellow
                    }
                    label={
                      isResolved
                        ? t('more_customer_cs_history_tab_status_complete')
                        : t('more_customer_cs_history_tab_status_progress')
                    }
                  />
                )}
                <Text className="font-medium2 block break-words">{title}</Text>
              </div>
              {createDt && (
                <Text className="font-small2 mt-4pxr block text-theme-solid-40">
                  {format(createDt, createDtFormat ?? DEFAULT_DATE_FORMAT)}
                </Text>
              )}
            </div>
            <Icon
              type={isActive ? IconType.ListArrowUp : IconType.ListArrowDown}
            />
          </div>
        </dt>
      );
    }
  ),
  areEqual
);

MoreExpandListItem.displayName = 'MoreExpandListItem';

function areEqual(
  prevProps: MoreExpandListItemProps,
  nextProps: MoreExpandListItemProps
) {
  return (
    prevProps.isActive === nextProps.isActive && prevProps.id === nextProps.id
  );
}

const DEFAULT_DATE_FORMAT = t('date_formatter_short_year_dot');

export {MoreExpandListItem};
